import React from "react";

export default function RefundPolicy() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-4">Cancellation &amp; Refund Policy</h1>
      <p className="text-slate-800 leading-7">
        Subscriptions provide immediate access to digital content. Therefore, payments are generally
        non-refundable once access is granted.
      </p>
      <p className="text-slate-800 leading-7 mt-4">
        If you are charged twice by mistake or face a payment error, contact us within 7 days at{" "}
        <a className="text-sky-600 hover:underline" href="mailto:nishatchadha@gmail.com">nishatchadha@gmail.com</a>{" "}
        and we’ll review and resolve it promptly.
      </p>
    </div>
  );
}
